/**
 * This is a dummy module file for development that is replaced in the grunt build by pre-compiled templates.
 */
angular.module('component-templates', []);
